import { createAction, props } from '@ngrx/store';
import { OutputFormat } from '@capital-access/common/actions';
import { SortDirection } from '@capital-access/common/utils';
import { HistoricalOwnershipReportFilters } from '../models/historical-ownership-filters.model';
import { IncludedContacts } from '../models/report-data.model';
import { ReportType } from '../models/report-type.enum';
import {
  ActivityHistoryFilterRequest,
  CommentRequest,
  ReportedQuartersFilterRequest,
  TemplateExportListItemWithComments
} from '../models/template-designer-state.model';

export const openHistoricalOwnershipReportDrawer = createAction(
  scoped`Open Historical Ownership Report Drawer`,
  props<{
    reportedQuarters: string[];
    filters?: HistoricalOwnershipReportFilters;
    sortDirection: SortDirection;
    displayCurrentBreakdown: boolean;
  }>()
);

export const createHistoricalOwnershipReportFinished = createAction(
  scoped`Create Historical Ownership report Finished`
);

export const createConfigurableProfileReport = createAction(
  scoped`Create Configurable Profile Report`,
  props<{
    profiles: { prId?: number; crmId?: number; name?: string }[];
    profileType: 'contact' | 'institution';
    templateId: number;
    activityHistoryFilters?: ActivityHistoryFilterRequest[];
    comments?: CommentRequest[];
    isExportLocalization?: boolean;
    reportedQuarters?: string[];
    isReportingExport?: boolean;
    includedContacts?: IncludedContacts[];
    moduleName?: string;
    reportedQuartersFilter?: ReportedQuartersFilterRequest[];
    outputFormat?: OutputFormat;
  }>()
);

export const createConfigurableProfileReportFinished = createAction(
  scoped`Create Configurable Profile Report Finished`
);

export const createBnyManagementReport = createAction(
  scoped`Create BNY Management Report`,
  props<{
    templateId: number;
    securityIds: number[];
    reportTime: Date;
    securityId: number; // This is the first securityId from the list, used for single security reports
  }>()
);

export const createBnyManagementReportFinished = createAction(scoped`Create BNY Management Report Finished`);

export const createConfigurableItineraryReport = createAction(
  scoped`Create Configurable Itinerary Report`,
  props<{
    templateId: number;
    eventId: string;
    activityIds?: string[];
    eventName?: string;
    sections?: string[];
    comments?: CommentRequest[];
    outputFormat?: OutputFormat;
  }>()
);

export const createConfigurableItineraryReportFinished = createAction(
  scoped`Create Configurable Itinerary Report Finished`,
  props<{ eventId: string }>()
);

export const loadSelectedItemsFromStorage = createAction(
  scoped`Load Selected Items From Storage`,
  props<{ selectedItems: TemplateExportListItemWithComments[] }>()
);

export const setZoomValue = createAction(scoped`Set Zoom Value`, props<{ zoom: number; savePrevious?: boolean }>());

export const resetZoomValue = createAction(scoped`Reset Zoom Value`);

export const loadSelectedTimeFromStorage = createAction(
  scoped`Load Selected Time From Storage`,
  props<{ selectedTime: string }>()
);

function scoped(templateString: TemplateStringsArray) {
  return '[Reporting Common] ' + templateString[0];
}

export const loadTemplateAction = createAction('[Profile Report] Load Template', props<{ reportType: ReportType }>());

export const removeLocalStorage = createAction(scoped`Remove Local Storage`, props<{ keys: string[] }>());
